export default __webpack_public_path__ + "static/bg1-3ae240dc8bf17f4cd6919db8b6b57d59.png";